import { createContext, useContext, useState } from 'react';

export type CurrencyCode = 'USD' | 'EUR' | 'GBP';

export interface Currency {
  code: CurrencyCode;
  symbol: string;
  flag: string;
  rate: number; // relative to USD
}

export const CURRENCIES: Currency[] = [
  { code: 'USD', symbol: '$', flag: '🇺🇸', rate: 1 },
  { code: 'EUR', symbol: '€', flag: '🇪🇺', rate: 0.92 },
  { code: 'GBP', symbol: '£', flag: '🇬🇧', rate: 0.79 },
];

interface CurrencyContextValue {
  currency: Currency;
  setCurrency: (c: Currency) => void;
  convert: (usdAmount: number) => number;
}

const CurrencyContext = createContext<CurrencyContextValue>({
  currency: CURRENCIES[0],
  setCurrency: () => {},
  convert: (n) => n,
});

export function CurrencyProvider({ children }: { children: React.ReactNode }) {
  const [currency, setCurrency] = useState<Currency>(CURRENCIES[0]);

  const convert = (usdAmount: number) =>
    Math.round(usdAmount * currency.rate);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, convert }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
